export const fcfa = (n) =>
  `${Number(n || 0).toLocaleString("fr-FR").replace(/[  ]/g, " ")} FCFA`;

export const ttc = (p) => (p.price || 0) + (p.shipping_fee || 0);

export const PAYMENT_LABELS = {
  wave: "Wave",
  orange_money: "Orange Money",
  card: "Carte bancaire",
};

export const STATUS_LABELS = {
  en_attente: "En attente",
  confirmee: "Confirmée",
  en_preparation: "En préparation",
  en_livraison: "En cours de livraison",
  livree: "Livrée",
  annulee: "Annulée",
};

export const PAYMENT_STATUS_LABELS = {
  en_attente: "En attente de vérification",
  acompte_recu: "Acompte reçu (50%)",
  payee: "Payée",
  echouee: "Échouée",
};
